// Include css
import './successModal.css';

// Ant design
import { Modal } from 'antd';

const showSuccessModal = (obj, seconds) => {
    // если передано время закрытия используем его (если нет = 5)
    let secondsToClose = (seconds ? seconds : 5);
    // создаем модальное окно
    const successEmployeeAction = Modal.confirm(obj);
    // обновляем кнопку
    setNewButtonCaption(successEmployeeAction, obj.okText, secondsToClose);
    // обновляем состоянии кнопки по счеткику
    const timer = setInterval(() => {
        secondsToClose -= 1;
        setNewButtonCaption(successEmployeeAction, obj.okText, secondsToClose);
    }, 1000);
    // закрываем окно по окончании отсчета
    setTimeout(() => {
        clearInterval(timer);
        successEmployeeAction.destroy();
    }, secondsToClose * 1000);
};

// дбавляем кол-во оставшихся до закрытия окна секунд к подписи кнопки
const setNewButtonCaption = (comp, text, seconds) => {
    comp.update({
        okText: text + " (" + seconds + ")",
    });
};

export default showSuccessModal;